import api from './api';

/**
 * @typedef {{
 *  nomeLoja: string,
 *  transportadoraServico: string,
 *  transportadoraTipo: number,
 *  prazo: number,
 *  ocorrencias: Array<{
 *      dataHora: string,
 *      descricao: string,
 *      descricaoTransportadora?: string,
 *      situacao: number,
 *      origem?: string,
 *      destino?: string | null
 *  }>
 *  rastreios: Array<{
 *      codigoRastreio: string,
 *      linkRastreio: string
 *  }>
 * }} RastreioResponse
 */

class RastreioServices {

    /**
     * @param codigoRastreio
     * @returns {Promise<RastreioResponse>}
     */

    static async getRastreio(codigoRastreio, recaptchaKey) {

        if (window.location.pathname.includes('/correios')) {
            const { data } = await api.get(`/rastreio/correios`,
                {
                    params:
                        { codigoRastreio, recaptchaKey }
                });
            return data;
        }

        const { data } = await api.get(`/rastreio`, { params: { codigoRastreio } });
        return data;
    }

}

export default RastreioServices;
